// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl: 'https://kyc.nixi.in',
  redirectSignIn: 'http://localhost:4200/auth/login',
  redirectSignOut: 'http://localhost:4200/login',
  GOOGLE_PLACE_API_KEY: 'google place api key',
    GOOGLE_PROXY_BASE_URL: 'http://localhost:4200',
    apiNixiBaseUrl: 'http://10.10.53.80:8080/',
    crypto_key: 'MTIzNDU2JCNAJF5ATklYSQ=='

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
